export default {
  data() {
    return {
      allCurrencies: [
        {
          code: 'USD',
          name: 'US Dollar',
          symbol: '$',
        },
        {
          code: 'EUR',
          name: 'Euro',
          symbol: '€',
        },
        {
          code: 'GBP',
          name: 'British Pound',
          symbol: '£',
        },
        {
          code: 'JPY',
          name: 'Japanese Yen',
          symbol: '¥',
        },
        {
          code: 'CAD',
          name: 'Canadian Dollar',
          symbol: 'C$',
        },
        {
          code: 'CHF',
          name: 'Swiss Franc',
          symbol: 'CHF',
        },
        {
          code: 'AUD',
          name: 'Australian Dollar',
          symbol: 'A$',
        },
        {
          code: 'BRL',
          name: 'Brazilian Real',
          symbol: 'R$',
        },
        {
          code: 'DKK',
          name: 'Danish Krone',
          symbol: 'kr.',
        },
        {
          code: 'HKD',
          name: 'Hong Kong Dollar',
          symbol: 'HK$',
        },
        {
          code: 'INR',
          name: 'Indian Rupee',
          symbol: '₹',
        },
        {
          code: 'NOK',
          name: 'Norwegian Krone',
          symbol: 'NOK',
        },
        {
          code: 'NZD',
          name: 'New Zealand Dollar',
          symbol: 'NZ$',
        },
        {
          code: 'SEK',
          name: 'Swedish Krona',
          symbol: 'SEK',
        },
        {
          code: 'SGD',
          name: 'Singapore Dollar',
          symbol: 'S$',
        },
        {
          code: 'TWD',
          name: 'New Taiwan Dollar',
          symbol: 'NT$',
        },
        {
          code: 'ZAR',
          name: 'South African Rand',
          symbol: 'R',
        },
      ],
    };
  },
  methods: {
    getCurrencySymbol(currencyCode) {
      const currency = this.allCurrencies.find((c) => c.code === currencyCode);
      return currency ? currency.symbol : currencyCode;
    },
  },
};
